import { COUNTRY_CODE } from "../enums/country-code.enum";

export const isArgentina = (country: string) => COUNTRY_CODE.ARGENTINA === country;
